<template>
  <div id="addEdit">
    <el-dialog title="资产详情" :visible.sync="visible" width="800px" @closed="detail.video=''">

      <div class="infoModel" v-if="detail!=null">

<!--
        <div class="info">
          <div class="tit">鉴定用户</div>
          <div class="text">
            <div class="userInfo">
              <img :src="detail.user.avatarUrl" alt="">
              <div class="main">
                <p class="name">{{ detail.user.nickName }}</p>
                <p class="text">ID:{{ detail.user.user_id }}</p>
              </div>
            </div>
          </div>
        </div> -->

        <div class="info">
          <div class="tit">标题</div>
          <div class="text">{{detail.title}}</div>
        </div>
        <div class="info">
          <div class="tit">描述</div>
          <div class="text">{{detail.description}}</div>
        </div>
        <div class="info">
          <div class="tit">分类</div>
          <div class="text">{{detail.category.name}}</div>
        </div>
        <div class="info">
          <div class="tit">品牌</div>
          <div class="text">{{detail.brand}}</div>
        </div>
        <div class="info">
          <div class="tit">成色</div>
          <div class="text">{{detail.fineness.name}}</div>
        </div>
        <div class="info">
          <div class="tit">附件</div>
          <div class="text">{{detail.attachment.map(item=>item.name).join('、')}}</div>
        </div>
        <div class="info">
          <div class="tit">城市</div>
          <div class="text">{{detail.city.name}}</div>
        </div>
        <div class="info">
          <div class="tit">价格</div>
          <div class="text">￥{{detail.price}}</div>
        </div>
        <div class="info">
          <div class="tit">配送方式</div>
          <div class="text"> {{deliveryList.find(item=>item.value==detail.delivery_type).label}}</div>
        </div>

        <div class="info">
          <div class="tit">详细地址</div>
          <div class="text">{{detail.address}}</div>
        </div>

        <div class="info">
          <div class="tit">状态</div>
          <div class="text">
            <el-tag size="small" :type="statusList.find(item=>item.value==detail.status).type">{{ statusList.find(item=>item.value==detail.status).label }}</el-tag>
          </div>
        </div>

        <div class="info">
          <div class="tit">视频</div>
          <div class="text">
            <video v-if="detail.video" :src="detail.video.file_path" fit="fill" controls style="width: 300px;height: 200px;"></video>
          </div>
        </div>
        <div class="info">
          <div class="tit">图片</div>
          <div class="text textImg">
            <el-image v-for="(item,index) in detail.images" :key="index" :src="item.file_path" fit="fill" :preview-src-list="detail.images.map(item=>item.file_path)"></el-image>
          </div>
        </div>

        <!-- <div class="info" v-if="detail.resultImage">
          <div class="tit">鉴定结果</div>
          <div class="text">
            <el-image :src="detail.resultImage.file_path" fit="fill" :preview-src-list="[detail.resultImage.file_path]"></el-image>
          </div>
        </div> -->

        <div class="info" v-if="type=='result'">
          <div class="tit">审核结果</div>
          <div class="text">
            <el-radio-group v-model="formData.status" size="small">
              <!-- <el-radio label="10">审核中</el-radio> -->
              <el-radio :label="20">通过</el-radio>
              <el-radio :label="30">拒绝</el-radio>
            </el-radio-group>
            <el-input v-if="formData.status==30" style="margin-top: 10px;" type="textarea" placeholder="请输入拒绝原因" v-model="formData.audit_remark"></el-input>
          </div>
        </div>

      </div>

      <div slot="footer" class="dialog-footer" v-if="type=='result'">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submitSave" :loading="loading">确定</el-button>
      </div>

      <div slot="footer" class="dialog-footer" v-else>
        <el-button type="primary" @click="visible = false">确定</el-button>
      </div>

    </el-dialog>

    <Upload v-if="isupload" :isupload="isupload" @returnImgs="uploadChange">上传图片</Upload>

  </div>
  </template>

  <script>
  import SecondhandApi from '@/api/secondhand'
  import Upload from '@/components/file/Upload';
  export default {
    components:{Upload},
    data(){
      return{
        loading:false,
        visible:false,
        isupload:false,
        detail:null,
        type:'',
        formData:{
          product_id:'',
          status:'',
          audit_remark:'',
        }
      }
    },
    props:{
      deliveryList:Array,
      statusList:Array,
    },
    methods:{

      /*提交保存*/
      submitSave(){
        let params = JSON.parse(JSON.stringify(this.formData));
        if(params.status==''||!params.status){
          this.$message({
            message: '请选择审核结果',
            type: 'error'
          });
          return
        }if(params.status==30&&params.audit_remark==''){
          this.$message({
            message: '请输入拒绝原因',
            type: 'error'
          });
          return
        }
        params.state=params.status
        this.loading = true;
        SecondhandApi.secondhandAudit(params).then(data => {
          this.$message({
            message: '保存成功',
            type: 'success'
          });
          this.visible=false
          this.$emit('refresh')
        }).finally(() => {
          this.loading = false;
        });
      },

      /*显示弹窗*/
      show(e,type){
        this.visible=true
        this.detail=e
        this.formData.product_id=e.product_id
        this.formData.status=''
        this.formData.audit_remark=''
        this.type=type
      },

      /*上传图片*/
      // uploadChange(e){
      //   // console.log(e);
      //   if(e&&e!=''){
      //     this.formData.resultImage=e[0];
      //   }
      //   this.isupload=false
      // },


    },

  }
  </script>

  <style lang="scss" scoped>
  .info{display: flex;font-size: 14px;
    .tit{width: 100px;}
    .text{flex: 1;}
  }
  .info+.info{padding-top: 10px;}
  .el-image{background: #f5f5f5;width: 80px;height: 80px;}
  .textImg{margin: -5px 0 0 -5px;
    .el-image{margin: 5px 0 0 5px;}
  }
  .img{padding-top: 10px;}
  .userInfo{display: flex;
    img{width: 40px;height: 40px;}
    .main{flex: 1;padding-left: 10px;
      .name{font-size: 14px;font-weight: bold;}
      .text{color:#999;}
    }
  }
  </style>


// WEBPACK FOOTER //
// src/views/secondhand/product/detail.vue